import { isHexPrefixed } from '@particle-network/auth';
import BigNumber from 'bignumber.js';
import BN from 'bn.js';
import numbro from 'numbro';
export const DecimalUnitMap = {
    1: 'wei',
    6: 'mwei',
    9: 'gwei',
    18: 'ether',
};
export function formatTokenAmount(amount, decimals = 0) {
    if (!amount) {
        return '0';
    }
    if (!parseInt(decimals.toString()) || parseInt(decimals.toString()) < 0) {
        decimals = 0;
    }
    return numbro(amount / Math.pow(10, decimals)).format({
        thousandSeparated: true,
        mantissa: decimals,
        trimMantissa: true,
    });
}
export function toWei(amount, unit = 'ether') {
    if (!amount) {
        return new BN(0);
    }
    const ethjs = require('ethjs-unit');
    return ethjs.toWei(amount, unit);
}
export function fromWei(amount, unit = 'ether', mantissa = 6) {
    if (!amount) {
        return '0';
    }
    const ethjs = require('ethjs-unit');
    let result;
    if (typeof amount === 'string' && amount.startsWith('0x')) {
        result = ethjs.fromWei(new BN(stripHexPrefix(amount), 16), unit);
    }
    else {
        if (typeof amount === 'number') {
            result = ethjs.fromWei(Math.round(amount), unit);
        }
        else {
            result = ethjs.fromWei(amount, unit);
        }
    }
    return numbro(result).format({
        thousandSeparated: true,
        trimMantissa: true,
        mantissa: mantissa,
    });
}
export function formatPrice(amount, price) {
    const value = Number(amount) * price;
    return `≈$${numbro(value).format({
        thousandSeparated: true,
        trimMantissa: true,
        mantissa: 2,
    })}`;
}
export function trimDecimals(value, mantissa) {
    return numbro(value).format({
        thousandSeparated: false,
        trimMantissa: true,
        mantissa: mantissa,
    });
}
export const formatAmount = (amount = 0, mantissa = 2) => {
    // return numbro(amount).format({
    //   thousandSeparated: true,
    //   trimMantissa: true,
    //   mantissa,
    // });
    return new BigNumber(amount).toFormat(Number(mantissa), 1).replace(/(?:\.0*|(\.\d+?)0+)$/, '$1');
};
export const shakeZero = (value) => {
    return value.toString().replace(/(?:\.0*|(\.\d+?)0+)$/, '$1');
};
/**
 * toNonExponential
 * @param num
 * @params mantissa
 * @returns
 */
export const toNonExponential = (num = 0, mantissa) => {
    let result = num.toString();
    try {
        if (typeof num == 'number') {
            var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
            // @ts-ignore
            num = num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
            if (mantissa) {
                // @ts-ignore
                num = num.toString().split('.')[0] + '.' + (num?.toString?.()?.split('.')?.[1]?.slice?.(0, mantissa) || '');
            }
            result = num.toString().replace(/(?:\.0*|(\.\d+?)0+)$/, '$1') || '0';
        }
    }
    catch (error) {
        console.log('toNonExponential', error);
    }
    return result;
};
export function stripHexPrefix(str) {
    if (typeof str !== 'string')
        throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return isHexPrefixed(str) ? str.slice(2) : str;
}
//# sourceMappingURL=number-utils.js.map